// API Imports
import { getModel } from '../../model/registry'
import useApi from '../../hooks/useApi';
import { useQuery } from '@tanstack/react-query'

//Import Read and Save to Local Store
import { saveToLS, getFromLS } from '../../utils/localStore/localStore';
import ClientVersion from '../../Version';

//Import Auth Hook
import useAuth from "../../hooks/useAuth"

//Import Translation Hook
import useTranslation from '../../hooks/useTranslation';
import { useModalStack } from '../../context/modalStackContext';


//Import the org Switcher functionality from useOrg
import useOrg from '../../hooks/useOrg';
import useProfile from '../../hooks/useProfile';
import { useSnapshot } from 'valtio';
import { Switcher } from '../generic/Switcher';
import { useNavigate } from 'react-router-dom';

//Import the popUp things
import { PopUp } from '../modal/PopUp';

const checkVersion = (version) => {
  const saved = localStorage.getItem('version');
  if (!saved) {
    saveToLS('version','client', version)
    return false
  }

  const savedVersion = JSON.parse(saved)

  if (savedVersion.client !== version && version !== ClientVersion) {
    return true
  }

  return false
}



function OrgSwitcher() {
  const { getMe } = useApi()
  const { Auth } = useAuth()
  const { switchOrg } = useOrg()
  const { pState } = useProfile()
  const profile = useSnapshot(pState)

  const { t } = useTranslation()
  const { pushModal } = useModalStack();
  const navigate = useNavigate();
  
  const getData = async () => {
    const resource = `userOrganization`
    const response = await getMe(resource)

    if (response?.meta?.clientVersion) {
      const update = checkVersion(response.meta.clientVersion)
      if (update) {
        pState.newVersion = update
      } else {
        pState.newVersion = false
      }
    }

    if (response && response?.data) {
      saveToLS('orgSwitcher','data',response.data)
      return response.data
    } else { 
      const localData = getFromLS('orgSwitcher','data')
      return localData
    }
  }

  //This is the function run by selecting an option on Switcher
  const handleSelect = async (option) => {
    await switchOrg(option.id)
    //Implement new Modal
    // Read when used: the registry holds the org's model only once it is loaded.
    const config = getModel('modalDialogData')['orgSwitch']
    const updatedConfig = { ...config };
    updatedConfig.params = [...(config.params || [])];
    //The option carries the new org name - pState.currentOrgName is only refreshed
    //by the initializeProfile effect, so it still holds the org we just left.
    updatedConfig.params[0] = option.name;
    pushModal(PopUp, { config: updatedConfig });
    navigate('/home');
  }

  //Retrieve the data from the API, Notice that order is passed as second param
  const result = useQuery({
    queryKey: ['userOrgs'],
    queryFn: getData
  })

  if (result.isLoading) {
    return <span>Loading...</span>
  }

  if (result.isError) {
    return <span>Error...</span>
  }

  if (result.isSuccess) {
    //Collect the Orgs to display

    const orgs = Array.isArray(result.data) ? result.data.map((item, key) => {
      return (
        //The Option array passed to switcher expects: type, id and name.
        { type: 'item', id: item.id, name: item.name })
    }) : []


    //Create the first two Rows and add the orgs in.
    //The Option array passed to switcher expects: type, id and name.
    const userInfo = [{ type: 'inactive', name: Auth.email, id: 'email' }, { type: 'divider', id: 'div1' }]
    const LogOutAction = [{ type: 'divider', id: 'div2' }, { type: 'action', name: t('orgSwitch.logout.action'), id: 'logOutButton', path: '/' }]
    const options = [...userInfo, ...orgs, ...LogOutAction]

    return (
      <Switcher type='org' currentOption={profile.currentOrgName} options={options} handleSelect={handleSelect} startPos={1} />
    )
  }
}

export default OrgSwitcher;
